module.exports = __webpack_public_path__ + "img/blue_158.7efe52fc.png";